var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgOrders = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 20,
  height: 17.917,
  x: 1.999,
  y: 3.334,
  fill: "#F6C561",
  rx: 1.667
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFF4BE",
  d: "M9.084 3.25h5.833V9.5H9.084z"
})));
export default SvgOrders;